<template>
  <div>
    <el-tabs v-model="currentTab.value" @tab-click="handleTabClick">
      <el-tab-pane label="线上数据" name="online"> </el-tab-pane>
      <el-tab-pane label="本地数据" name="local"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Message from '@/components/Message'
export default {
  name: "WebSaaSHeader",
  inject: ["currentTab", "setTab", "getList"],
  data() {
    return {};
  },

  methods: {
    /** 标签页切换的事件 */
    handleTabClick(tab) {
      console.log("标签页切换的事件", tab.name);
      this.setTab(tab.name);
      this.getList();
      Message.success("切换成功");
    },
  },
};
</script>

<style lang="scss" scoped></style>